import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=70e73eac&scoped=true&"
import script from "./tree.ts?vue&type=script&lang=ts&"
export * from "./tree.ts?vue&type=script&lang=ts&"
import style0 from "./tree.scss?vue&type=style&index=0&id=70e73eac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e73eac",
  null
  
)

export default component.exports